module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_4.3ce314f9.jpg";